/**
 * WPS Logs Services - API service layer for WPS logging operations
 * Handles logging and audit trail functionality for WPS operations
 */
import axios from "axios";

// Dynamic API URL configuration based on environment
let GROOVE_API_URL;

if (process.env.REACT_APP_NODE_ENV === "local") {
  GROOVE_API_URL = process.env.REACT_APP_WPS_GROOVE_API_URL;
} else {
  GROOVE_API_URL = process.env.REACT_APP_API_URL + "/wps";
}

/**
 * Add new log entry for WPS operations
 * @param {Object} wld_WPS_Logs - Log data containing user actions, timestamps, and WPS changes
 * @returns {Object} API response data
 */
export const AddLogs = async (wld_WPS_Logs) => {
  let url = `${GROOVE_API_URL}/WpsLogs`;
  const response = await axios.post(url, wld_WPS_Logs).then(function (resp) {
    return resp;
  })
    .catch(function (error) {
      return { message: "Unable to find request", status: false };
    });
  return response.data;
}; 